const WhitelistedKeys = {
  npi: 'NPI',
  dea: 'DEA',
  ssn: 'SSN',
  cds: 'CDS',
  caqh: 'CAQH',
  npdb: 'NPDB',
  id: 'ID',
  fnin: 'FNIN',
  upin: 'UPIN',
  ecfmg: 'ECFMG',
  usmle: 'USMLE',
  dob: 'DOB',
  zip: 'ZIP',
  moc: 'MOC',
  svc: 'SVC',
  abmsuid: 'ABMSUID',
  dcn: 'DCN',
  '(moc)': '(MOC)',
  ama: 'AMA',
  nccpa: 'NCCPA',
  fi: 'FI',
  fips: 'FIPS',
  dhcs: 'DHCS',
  anc: 'ANC',
  cd: 'CD',
  nemt: 'NEMT',
  nmt: 'NMT',
  dba: 'DBA',
  tin: 'TIN',
  pecos: 'PECOS',
  pac: 'PAC',
  nucc: 'NUCC'
};

export const transformListKey = (key: string): string => {
  // @@ is used for handling duplicate entries in list,
  // which will be removed from the key on runtime parsing.
  if (key?.includes('@@')) {
    key = key?.replace(/@@.*/gi, '');
  }
  // % is used for handling the exact case in the list.
  if (key?.startsWith('%')) {
    return key?.replace(/%/gi, '');
  }
  const keyArr = key
    ?.upperStringToLowerCase()
    ?.capitaliseFirstString()
    ?.withSpaceAfterCapitalLetters()
    ?.split(' ');
  keyArr.forEach((k, i) => {
    const val = WhitelistedKeys[k?.toLowerCase()];
    if (val) {
      keyArr[i] = val;
    }
  });
  return keyArr?.join(' ');
};
